import React from 'react';
import Contenido from '../../../layout/Contenido';
import { useSelector } from 'react-redux';
import TablaPedidos from '../../tablas/TablaPedidos';
import { getPedidosCompletosInglaterra } from '../../../utils';
import { blue } from '@material-ui/core/colors';

export default function Inglaterra() {
	const { fetching, ultimaActualizacion, pedidos } = useSelector(
		(content) => content.Pedidos
	);

	return (
		<Contenido title='Pedidos de Inglaterra' color={blue[700]}>
			<div
				style={{
					height: '100%',
					width: '100%',
				}}>
				<TablaPedidos
					loading={fetching && ultimaActualizacion === null}
					pedidos={getPedidosCompletosInglaterra(pedidos)}
					showBloquear={true}
					showPreparar={true}
					showPedidosATienda={true}
					pdfTitle='Pedidos de Inglaterra'
				/>
			</div>
		</Contenido>
	);
}
